import { MenuItem, Select, Typography } from '@material-ui/core'
import { ArrowForward } from '@material-ui/icons'
import { LanguageFlag } from 'components/facets/LanguageFlag'
import {
  forwardRef,
  ForwardRefRenderFunction,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import { CARD_LANGUAGES_WITH_FLAGS } from 'shared'

export interface EditLanguageCellInterface {
  locationName: any
  oldValue: number
  setNewIdLanguage: any
  disabled: boolean
}

export interface EditLanguageCellRef {
  resetValue: () => void
}

const EditLanguageCell: ForwardRefRenderFunction<EditLanguageCellRef, EditLanguageCellInterface> = (
  { locationName, oldValue, setNewIdLanguage, disabled },
  ref
) => {
  const [hasEditedValue, setHasEditedValue] = useState(false)
  const [newEditedValue, setNewEditedValue] = useState(oldValue)

  useImperativeHandle(ref, () => ({
    resetValue() {
      setNewEditedValue(oldValue)
      setNewIdLanguage(oldValue)
    },
  }))

  const handleChanges = (event: any) => {
    setNewIdLanguage(event.target.value)
    setNewEditedValue(event.target.value)
  }

  useEffect(() => {
    const newValue = CARD_LANGUAGES_WITH_FLAGS.find((language) => language.value === newEditedValue)
    if (oldValue === newValue!.value) setHasEditedValue(false)
    else setHasEditedValue(true)
  }, [oldValue, newEditedValue])

  const oldValueLabel = CARD_LANGUAGES_WITH_FLAGS.find((language) => language.value === oldValue)

  return hasEditedValue ? (
    <div className="d-flex flex-row justify-content-center align-items-center">
      <Typography>{oldValueLabel?.label}</Typography>
      <ArrowForward className="mx-1" />

      <Select value={newEditedValue} onChange={(e) => handleChanges(e)} className="locations-panel">
        {CARD_LANGUAGES_WITH_FLAGS.map((language) => (
          <MenuItem
            data-testid={`languageValue-${language.value}`}
            key={language.value}
            value={language.value}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <LanguageFlag
                style={{ padding: '0px 5px' }}
                height="15"
                code={language.code || 'gg'}
              />
            </div>
          </MenuItem>
        ))}
      </Select>
    </div>
  ) : (
    <Select
      className="locations-panel"
      data-testid={`language-${locationName}`}
      value={newEditedValue}
      onChange={(e) => {
        handleChanges(e)
      }}
      // className={isEdited('language') ? classes.edited : ''}
      style={{ width: '60px' }}
      disabled={disabled}
    >
      {CARD_LANGUAGES_WITH_FLAGS.map((language) => (
        <MenuItem
          data-testid={`languageValue-${language.value}`}
          key={`${locationName}-${language.value}`}
          value={language.value}
        >
          {language.label}
        </MenuItem>
      ))}
    </Select>
  )
}

export default forwardRef(EditLanguageCell)
